/*
 * @Author: 张印 hbzyin@163.com
 * @Date: 2023-08-09 15:32:13
 * @LastEditors: 张印 hbzyin@163.com
 * @LastEditTime: 2023-08-18 15:50:34
 * @FilePath: /mall-fe/src/comps/HomeHireBannerH5.tsx
 * @Description: 招租广告位组件
 *
 */
import React, { useContext } from 'react';
import { DeviceContext } from 'libs/contexts';
import Banner from 'views/h5/Home/components/Banner';
import HireBannerTagImg from 'images/cscec3b/hireAd/hire-banner-tag-m';
import HireBannerTagImgW from 'images/cscec3b/hireAd/hire-banner-tag-mw';
import { webps } from 'libs/imgs';
webps[HireBannerTagImg] = HireBannerTagImgW;
const HomeHireBannerMobile = (props: {
  hireBannerMobData: Array<BannerEntity>;
  isQywx: boolean;
}) => {
  const { buildImgSrc } = useContext(DeviceContext);
  return (
    <>
      {props.hireBannerMobData?.length > 0 && (
        <div className="hire-banner-mobile">
          <i className="left-ads-tag" />
          <Banner banners={props.hireBannerMobData.slice(0, 8)} isQywx={props.isQywx} />
        </div>
      )}
      <style jsx>{`
        .hire-banner-mobile {
          position: relative;
          padding-left: 65px;
        }
        .left-ads-tag {
          width: 69px;
          height: 138px;
          background-image: url(${buildImgSrc(HireBannerTagImg)});
          background-size: 100% 100%;
          background-repeat: no-repeat;
          background-position: center;
          position: absolute;
          top: 0;
          left: 12px;
        }
      `}</style>
    </>
  );
};

export default HomeHireBannerMobile;
